(function () {
"use strict";
var APEX_URL   = "https://njordgearco.com/products/the-indestructible-smartwatch-apex";
var BUNDLE_URL = "https://njordgearco.com/products/the-working-man-s-bundle-apex-edition";
var ASSETS = (window.NJORD_QUIZ_ASSETS || { apex: "", bundle: "" });
window._learnq = window._learnq || [];
var state = {
tradeValue: null,
totalScore: 0,
giftFlag: false,
resultType: null,
emailCaptured: false
};
var QUESTIONS = [
{
id: "q1",
type: "grid",
eyebrow: "YOUR TRADE",
question: "What's your trade?",
subtitle: "Your job determines which features matter most on your wrist.",
options: [
{ label: "Plumber",        icon: "ti-tool",       value: "Plumber" },
{ label: "Mechanic",       icon: "ti-engine",     value: "Mechanic" },
{ label: "Landscaper",     icon: "ti-plant",      value: "Landscaper" },
{ label: "Farmer",         icon: "ti-tractor",    value: "Farmer" },
{ label: "Welder",         icon: "ti-flame",      value: "Welder" },
{ label: "Carpenter",      icon: "ti-hammer",     value: "Carpenter" },
{ label: "Electrician",    icon: "ti-bolt",       value: "Electrician" },
{ label: "Millwright",     icon: "ti-settings-2", value: "Millwright" },
{ label: "Construction",   icon: "ti-building",   value: "Construction" },
{ label: "Logging",        icon: "ti-trees",      value: "Logging" },
{ label: "Law Enforcement",icon: "ti-shield",     value: "Law Enforcement" },
{ label: "Other",          icon: "ti-dots",       value: "Other" }
]
},
{
id: "q2",
type: "list",
eyebrow: "YOUR ENVIRONMENT",
question: "What does your job site look like?",
subtitle: "Tells us how sealed and protected your watch needs to be.",
options: [
{ label: "Dusty, gritty, or grimy most days", points: 2 },
{ label: "Wet, muddy, or rain-exposed",       points: 2 },
{ label: "Mix of both",                       points: 3 },
{ label: "Mostly clean indoors",              points: 0 }
]
},
{
id: "q3",
type: "list",
eyebrow: "YOUR CONDITIONS",
question: "Where do you check your watch most?",
subtitle: "Direct sun needs a different screen than indoor work.",
options: [
{ label: "Outside in full sun most of the day", points: 1 },
{ label: "Mix of sun and shade",                points: 1 },
{ label: "Mostly indoors or covered",           points: 0 },
{ label: "Changes day to day",                  points: 1 }
]
},
{
id: "q4",
type: "list",
eyebrow: "WATER EXPOSURE",
question: "How does your watch get wet?",
subtitle: "Determines the waterproofing level you actually need.",
options: [
{ label: "Fully submerged — swimming or diving", points: 2 },
{ label: "Power-washed or hosed down on site",   points: 2 },
{ label: "Rain and sweat only",                  points: 1 },
{ label: "Stays mostly dry",                     points: 0 }
]
},
{
id: "q5",
type: "list",
eyebrow: "YOUR GEAR HABITS",
question: "How do you go through gear?",
subtitle: "Helps us figure out if you need the full kit or just the watch.",
options: [
{ label: "I destroy everything I own",                    points: 3 },
{ label: "Hard on gear but I take care of my stuff",      points: 2 },
{ label: "Pretty easy on my gear",                        points: 0 },
{ label: "Buying this as a gift",                         points: 3, gift: true }
]
}
];
var TOTAL_Q = QUESTIONS.length;
var FAQ_APEX = [
["What's included in my order?", "Watch, charging cable, extra strap, and quick-start guide. Ships in 1–3 business days."],
["Will it hold up on a job site?", "MIL-STD-810G certified. Tested for drops, vibration, extreme temps, and high-pressure water. Full metal alloy case — not plastic."],
["Does it work with my phone?", "Works with iOS and Android. Pairs via Bluetooth. No subscription needed."],
["Is there a guarantee?", "30-day money-back guarantee. If it doesn't hold up, you get your money back."],
["Will it fit my wrist?", "Adjustable band fits most wrist sizes. Two band sizes included in the box."],
["Is it bulky?", "Slightly larger than a standard watch to protect the hardware. Most guys forget it's there after the first week."]
];
var FAQ_BUNDLE = [
["What's included in the bundle?", "APEX watch, extra silicone band, charging cable, NjordCare+ protection plan, and quick-start guide."],
["Will it hold up on a job site?", "MIL-STD-810G certified. Tested for drops, vibration, extreme temps, and high-pressure water. Full metal case — not plastic."],
["What is NjordCare+?", "Extended protection plan. Covers damage beyond the standard warranty. $6.49/month — first month included free in the bundle."],
["Does it work with my phone?", "Works with iOS and Android. Pairs via Bluetooth. No subscription needed."],
["Is there a guarantee?", "30-day money-back guarantee. If it doesn't hold up, you get your money back."],
["Will it fit my wrist?", "Adjustable band fits most wrist sizes. Two band sizes included in the box."]
];
function esc(str) {
return String(str).replace(/[&<>"']/g, function (c) {
return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
});
}
function imgHtml(src, fallbackLabel) {
var safeSrc = src ? esc(src) : "";
return '<div class="nq-img">' +
(safeSrc
? '<img src="' + safeSrc + '" alt="" onerror="this.style.display=\'none\';this.parentNode.querySelector(\'.nq-img-ph\').style.display=\'flex\';">'
: "") +
'<div class="nq-img-ph"' + (safeSrc ? ' style="display:none"' : ' style="display:flex"') + '>' + esc(fallbackLabel) + '</div>' +
'</div>';
}
function showScreen(el) {
var current = document.querySelector("#njord-quiz .nq-screen.active");
if (current === el) return;
function reveal() {
el.style.display = "block";
el.classList.add("active");
void el.offsetWidth;
el.style.opacity = "1";
window.scrollTo(0, 0);
}
if (current) {
current.style.opacity = "0";
setTimeout(function () {
current.classList.remove("active");
current.style.display = "none";
reveal();
}, 200);
} else {
reveal();
}
}
function updateProgress(qIndex) {
var n = qIndex + 1;
var pct = Math.round((n / TOTAL_Q) * 100);
var fills = document.querySelectorAll("#njord-quiz .nq-fill");
var counts = document.querySelectorAll("#njord-quiz .nq-pl-count");
var pcts = document.querySelectorAll("#njord-quiz .nq-pl-pct");
for (var i = 0; i < fills.length; i++) fills[i].style.width = pct + "%";
for (var j = 0; j < counts.length; j++) counts[j].textContent = "Question " + n + " of " + TOTAL_Q;
for (var k = 0; k < pcts.length; k++) pcts[k].textContent = pct + "%";
}
function buildQuestions() {
var host = document.getElementById("nq-questions");
QUESTIONS.forEach(function (q, qIndex) {
var sec = document.createElement("section");
sec.className = "nq-screen nq-q";
sec.id = "nq-" + q.id;
var optsHtml = "";
if (q.type === "grid") {
optsHtml = '<div class="nq-grid">';
q.options.forEach(function (opt, oi) {
optsHtml +=
'<div class="nq-card" data-qi="' + qIndex + '" data-oi="' + oi + '">' +
'<i class="ti ' + opt.icon + '"></i>' +
'<span>' + esc(opt.label) + '</span>' +
'</div>';
});
optsHtml += "</div>";
} else {
optsHtml = '<div class="nq-list">';
q.options.forEach(function (opt, oi) {
optsHtml +=
'<div class="nq-card" data-qi="' + qIndex + '" data-oi="' + oi + '">' +
'<span class="nq-radio"></span>' +
'<span class="nq-card-label">' + esc(opt.label) + '</span>' +
'</div>';
});
optsHtml += "</div>";
}
sec.innerHTML =
'<div class="nq-progress"><div class="nq-progress-inner">' +
'<div class="nq-track"><div class="nq-fill"></div></div>' +
'<div class="nq-progress-labels">' +
'<span class="nq-pl-count nq-mono"></span>' +
'<span class="nq-pl-pct nq-mono"></span>' +
'</div>' +
'</div></div>' +
'<div class="nq-q-body">' +
'<p class="nq-eyebrow">' + esc(q.eyebrow) + '</p>' +
'<h2 class="nq-question">' + esc(q.question) + '</h2>' +
'<p class="nq-q-subtitle">' + esc(q.subtitle) + '</p>' +
optsHtml +
'</div>';
host.appendChild(sec);
});
host.addEventListener("click", function (e) {
var card = e.target.closest(".nq-card");
if (!card) return;
var qi = parseInt(card.getAttribute("data-qi"), 10);
var oi = parseInt(card.getAttribute("data-oi"), 10);
selectOption(qi, oi, card);
});
}
var advancing = false;
function selectOption(qi, oi, cardEl) {
if (advancing) return;
advancing = true;
var q = QUESTIONS[qi];
var opt = q.options[oi];
var siblings = cardEl.parentNode.querySelectorAll(".nq-card");
for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove("sel");
cardEl.classList.add("sel");
if (qi === 0) {
state.tradeValue = opt.value;
} else {
state.totalScore += (opt.points || 0);
if (opt.gift) state.giftFlag = true;
}
setTimeout(function () {
advancing = false;
if (qi + 1 < TOTAL_Q) {
goToQuestion(qi + 1);
} else {
showScreen(document.getElementById("nq-email"));
}
}, 300);
}
function goToQuestion(qIndex) {
updateProgress(qIndex);
showScreen(document.getElementById("nq-" + QUESTIONS[qIndex].id));
}
function computeResult() {
var type = state.totalScore >= 8 ? "bundle" : "apex-solo";
if (state.giftFlag) type = "bundle";
state.resultType = type;
return type;
}
function featureHtml(features) {
var html = '<div class="nq-feature-grid">';
features.forEach(function (f) {
html += '<div class="nq-feature"><i class="ti ' + f[0] + '"></i>' + esc(f[1]) + '</div>';
});
html += "</div>";
return html;
}
function faqHtml(faqs) {
var html =
'<div class="nq-faq-sec"><div class="nq-faq-sec-inner">' +
'<p class="nq-faq-eyebrow">Common Questions</p>';
faqs.forEach(function (f) {
html +=
'<div class="nq-faq-item">' +
'<div class="nq-faq-q"><span>' + esc(f[0]) + '</span><i class="ti ti-plus"></i></div>' +
'<div class="nq-faq-a"><p>' + esc(f[1]) + '</p></div>' +
'</div>';
});
html += "</div></div>";
return html;
}
function renderResult() {
var type = computeResult();
var resultEl = document.getElementById("nq-result");
try { sessionStorage.setItem("njord_quiz_result", type); } catch (e) {}
var cfg;
if (type === "apex-solo") {
cfg = {
badge: "YOUR MATCH",
headline: "Built for your job. The APEX.",
subhead: "Full metal. IP69K sealed. 18-day battery. This is the one you buy once — not every year.",
img: ASSETS.apex,
imgFallback: "[APEX Watch]",
name: "The Indestructible Smartwatch APEX",
priceOld: "$219.99",
priceNew: "$139.99",
features: [
["ti-droplet-off", "IP69K sealed"],
["ti-shield-check", "MIL-STD-810G"],
["ti-battery-charging", "18-day battery"],
["ti-message", "Text from wrist"],
["ti-sun", "Outdoor display"],
["ti-cube", "Full metal case"]
],
cta: "Get the APEX &rarr;",
ctaUrl: APEX_URL,
secondary: {
eyebrow: "MOST WORKERS ALSO ADD",
headline: "The Working Man's Bundle",
body: "Extra band + NjordCare+ protection. Guys who work like you don't just buy the watch.",
cta: "Upgrade to the full kit &rarr;",
url: BUNDLE_URL
},
faqs: FAQ_APEX
};
} else {
cfg = {
badge: "YOUR MATCH",
headline: state.giftFlag
? "The only gift he'll actually use. The Working Man's Bundle."
: "You need the full kit. The Working Man's Bundle.",
subhead: state.giftFlag
? "Not a gadget. Something he'll wear every single day on the job."
: "Based on how hard you run your gear — the watch alone isn't enough.",
img: ASSETS.bundle,
imgFallback: "[Bundle Kit]",
name: "Working Man's Bundle — APEX Edition",
priceOld: "$239.99",
priceNew: "$149.99",
features: [
["ti-droplet-off", "IP69K sealed"],
["ti-shield-check", "MIL-STD-810G"],
["ti-battery-charging", "18-day battery"],
["ti-message", "Text from wrist"],
["ti-refresh", "Backup band incl."],
["ti-heart-check", "NjordCare+ incl."]
],
cta: "Get the Bundle &rarr;",
ctaUrl: BUNDLE_URL,
secondary: {
eyebrow: "JUST THE WATCH INSTEAD?",
headline: "APEX Solo — $139.99",
body: "Watch only. No backup band or protection plan. Most guys who work like you go with the full kit.",
cta: "Get APEX solo instead &rarr;",
url: APEX_URL
},
faqs: FAQ_BUNDLE
};
}
var priceSensitivity = "";
if (type === "apex-solo" && state.totalScore <= 3) {
priceSensitivity =
'<div class="nq-price-sensitivity"><p>' +
"Most guys look at the $50 difference and think it's not worth it. Then they buy the cheaper one, " +
"it cracks on a job site six months in, and they're back here anyway. The APEX is the one you buy once." +
"</p></div>";
}
var html =
'<div class="nq-topbar"></div>' +
'<div class="nq-restart"><div class="nq-restart-inner" id="nq-restart">' +
'<i class="ti ti-refresh"></i><span>Start over</span>' +
'</div></div>' +
'<div class="nq-result-head"><div class="nq-result-head-inner">' +
'<span class="nq-match-badge">' + esc(cfg.badge) + '</span>' +
'<h2>' + esc(cfg.headline) + '</h2>' +
'<p class="nq-sub">' + esc(cfg.subhead) + '</p>' +
'</div></div>' +
'<div class="nq-product-sec"><div class="nq-product-sec-inner">' +
'<div class="nq-card-product">' +
imgHtml(cfg.img, cfg.imgFallback) +
'<div class="nq-product-body">' +
'<p class="nq-product-name">' + esc(cfg.name) + '</p>' +
'<p class="nq-price"><span class="nq-old">' + esc(cfg.priceOld) + '</span>' +
'<span class="nq-new">' + esc(cfg.priceNew) + '</span></p>' +
featureHtml(cfg.features) +
'</div>' +
'</div>' +
'<div class="nq-code-chip" id="nq-code-chip">' +
'<span class="nq-code-left">QUIZ10</span>' +
'<span class="nq-code-right" id="nq-code-right"><i class="ti ti-copy"></i><span id="nq-code-txt">tap to copy</span></span>' +
'</div>' +
'<p class="nq-timer" id="nq-timer">Code expires in --:--:--</p>' +
'<a class="nq-btn nq-main-cta" href="' + esc(cfg.ctaUrl) + '" id="nq-main-cta">' + cfg.cta + '</a>' +
'<div class="nq-secondary-block">' +
'<p class="nq-sb-eyebrow">' + esc(cfg.secondary.eyebrow) + '</p>' +
'<p class="nq-sb-headline">' + esc(cfg.secondary.headline) + '</p>' +
'<p class="nq-sb-body">' + esc(cfg.secondary.body) + '</p>' +
'<a class="nq-btn-ghost" href="' + esc(cfg.secondary.url) + '">' + cfg.secondary.cta + '</a>' +
'</div>' +
priceSensitivity +
'</div></div>' +
faqHtml(cfg.faqs);
resultEl.innerHTML = html;
wireResultInteractions();
startCountdown();
fireQuizCompleted();
showScreen(resultEl);
}
function wireResultInteractions() {
var restart = document.getElementById("nq-restart");
if (restart) restart.addEventListener("click", function () { window.location.reload(); });
var chip = document.getElementById("nq-code-chip");
if (chip) {
chip.addEventListener("click", function () {
copyText("QUIZ10");
var right = document.getElementById("nq-code-right");
var txt = document.getElementById("nq-code-txt");
var icon = right.querySelector("i");
right.classList.add("copied");
if (icon) icon.className = "ti ti-check";
txt.textContent = "Copied ✓";
setTimeout(function () {
right.classList.remove("copied");
if (icon) icon.className = "ti ti-copy";
txt.textContent = "tap to copy";
}, 2000);
});
}
var items = document.querySelectorAll("#nq-result .nq-faq-item");
for (var i = 0; i < items.length; i++) {
(function (item) {
item.querySelector(".nq-faq-q").addEventListener("click", function () {
item.classList.toggle("open");
});
})(items[i]);
}
}
function copyText(text) {
if (navigator.clipboard && navigator.clipboard.writeText) {
navigator.clipboard.writeText(text).catch(function () { legacyCopy(text); });
} else {
legacyCopy(text);
}
}
function legacyCopy(text) {
try {
var ta = document.createElement("textarea");
ta.value = text;
ta.style.position = "fixed";
ta.style.opacity = "0";
document.body.appendChild(ta);
ta.select();
document.execCommand("copy");
document.body.removeChild(ta);
} catch (e) {}
}
var countdownTimer = null;
function startCountdown() {
var expiry;
try {
expiry = sessionStorage.getItem("njord_quiz_expiry");
if (!expiry) {
expiry = Date.now() + 86400000;
sessionStorage.setItem("njord_quiz_expiry", String(expiry));
}
expiry = parseInt(expiry, 10);
} catch (e) {
expiry = Date.now() + 86400000;
}
var el = document.getElementById("nq-timer");
function pad(n) { return (n < 10 ? "0" : "") + n; }
function tick() {
var rem = expiry - Date.now();
if (rem <= 0) {
el.textContent = "Code expired";
if (countdownTimer) clearInterval(countdownTimer);
return;
}
var totalSec = Math.floor(rem / 1000);
var h = Math.floor(totalSec / 3600);
var m = Math.floor((totalSec % 3600) / 60);
var s = totalSec % 60;
el.textContent = "Code expires in " + pad(h) + ":" + pad(m) + ":" + pad(s);
}
tick();
if (countdownTimer) clearInterval(countdownTimer);
countdownTimer = setInterval(tick, 1000);
}
function fireIdentify(email) {
window._learnq.push(["identify", {
"$email": email,
"Trade": state.tradeValue,
"Quiz Score": state.totalScore,
"Quiz Result": state.resultType
}]);
}
function fireQuizCompleted() {
window._learnq.push(["track", "Quiz Completed", {
result: state.resultType,
score: state.totalScore,
trade: state.tradeValue,
gift: state.giftFlag,
email_captured: state.emailCaptured
}]);
}
function isValidEmail(v) {
return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}
function submitEmail() {
var input = document.getElementById("nq-email-input");
var email = (input.value || "").trim();
if (!isValidEmail(email)) {
input.classList.add("nq-err");
input.focus();
return;
}
input.classList.remove("nq-err");
computeResult();
state.emailCaptured = true;
fireIdentify(email);
try { localStorage.setItem("njord_quiz_email", email); } catch (e) {}
renderResult();
}
function skipEmail() {
state.emailCaptured = false;
renderResult();
}
function init() {
buildQuestions();
document.getElementById("nq-start").addEventListener("click", function () {
goToQuestion(0);
});
document.getElementById("nq-email-submit").addEventListener("click", submitEmail);
document.getElementById("nq-email-input").addEventListener("keydown", function (e) {
if (e.key === "Enter") submitEmail();
});
document.getElementById("nq-email-input").addEventListener("input", function () {
this.classList.remove("nq-err");
});
document.getElementById("nq-skip").addEventListener("click", skipEmail);
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", init);
} else {
init();
}
})();